export const prismaModelName = Symbol.for("Pothos.prismaModelName");
//# sourceMappingURL=types.js.map
